<template>
  <div>
    <el-row class="padding-bottom-row">
      <el-col :span="2">
        <div class="content-label">换货采购列表</div>
      </el-col>
      <el-col :span="22">
        <el-row
          class="padding-bottom-row"
          v-if="exchangeRefundInfo.operateType == 1"
        >
          <el-button type="primary" size="mini" @click="addStoreIn()"
            >新增换货采购</el-button
          >
          <el-button
            type="primary"
            size="mini"
            @click="dialogFormVisible = true"
            >绑定采购记录</el-button
          >
        </el-row>
        <el-row>
          <el-table :data="tableData" border>
            <el-table-column prop="" label="创建时间">
              <template v-slot="scope">
                {{ scope.row.createTime.split(" ")[0] }}
                <br />
                {{ scope.row.createTime.split(" ")[1] }}
              </template>
            </el-table-column>
            <el-table-column prop="rawMaterialId" label="材料id">
            </el-table-column>
            <el-table-column label="采购编号">
              <template v-slot="scope">
                <el-button type="text" @click="goStoreIn(scope.row.id)">{{
                  scope.row.id
                }}</el-button>
              </template>
            </el-table-column>
            <el-table-column prop="logisticsOrderNo" label="换货物流单号">
            </el-table-column>
            <el-table-column prop="logisticsOrgTypeLabel" label="换货物流公司">
            </el-table-column>
            <el-table-column prop="quantity" label="换货数量">
            </el-table-column>
            <el-table-column prop="" label="换货金额">
              <template v-slot="scope">
                {{
                  (
                    scope.row.quantity * parseFloat(scope.row.unitPrice)
                  ).toFixed(2)
                }}
              </template>
            </el-table-column>

            <el-table-column prop="inboundQuantity" label="质检入库">
            </el-table-column>
            <el-table-column prop="damageQuantity" label="损毁">
            </el-table-column>
            <el-table-column prop="returnQuantity" label="退货">
            </el-table-column>
            <el-table-column prop="remark" label="备注"> </el-table-column>
            <el-table-column prop="" label="操作">
              <template v-slot="scope">
                <el-button
                  type="text"
                  @click="unbind(scope.row.id)"
                  size="mini"
                >
                  解除绑定
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-row>
      </el-col>
    </el-row>
    <el-dialog title="绑定采购记录" :visible.sync="dialogFormVisible">
      <el-form :model="form">
        <el-form-item label="采购编号" :label-width="formLabelWidth">
          <el-input v-model="form.id" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="bindStoreIn">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { inboundModules } from "@r";
export default {
  props: {
    tableData: {
      type: Array,
      default() {
        return [];
      },
    },
    exchangeRefundInfo: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      dialogFormVisible: false,
      formLabelWidth: "100px",
      form: {
        id: "",
        relationReturnLogisticsOrgType: this.exchangeRefundInfo
          .relationReturnLogisticsOrgType,
        relationReturnLogisticsOrderNo: this.exchangeRefundInfo
          .relationReturnLogisticsOrderNo,
        supplierId: this.exchangeRefundInfo.supplierId,
      },
    };
  },
  activated() {},
  methods: {
    goStoreIn(id) {
      this.$emit("go-store-in", id);
    },
    addStoreIn() {
      this.$router.push({
        path: "/client/addExchangePurchase",
        query: { id: this.exchangeRefundInfo.id, operateType: 1 },
      });
    },
    bindStoreIn() {
      if (["", undefined, null].includes(this.form.id)) {
        return;
      }
      inboundModules.unbindLogisticsInfo(this.form).then((res) => {
        if (res.result !== 1) {
          return;
        }
        this.$message({
          type: "success",
          message: "绑定成功!",
        });
        this.$emit("request-data");
      });
    },
    unbind(id) {
      this.$confirm("是否确定解除绑定？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          inboundModules
            .unbindLogisticsInfo({
              id: id,
            })
            .then((res) => {
              if (res.result !== 1) {
                return;
              }
              this.$message({
                type: "success",
                message: "删除成功!",
              });
              this.$emit("request-data");
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
  },
};
</script>

<style>
</style>